module.exports = __webpack_public_path__ + "static/media/notification-notification.4ee1f1bc.mp3";